import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { TSitecoreContext } from '../../../types/sitecore.types';
import {
  TProductModelDetailsSpecificationTableBackgroundImage,
  TProductModelDetailsSpecificationTableFields,
  TProductModelDetailsSpecificationTableGroups,
  TProductModelDetailsSpecificationTableProps,
} from '../types/index.types';

export class TProductModelDetailsSpecificationTableModel {
  private readonly fields?: TProductModelDetailsSpecificationTableFields;
  private readonly rendering?: ComponentRendering;
  private readonly context?: TSitecoreContext;

  constructor(props: TProductModelDetailsSpecificationTableProps) {
    this.fields = props?.fields;
    this.rendering = props?.rendering;
    this.context = props?.sitecoreContext;
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get groups(): Array<TProductModelDetailsSpecificationTableGroups> {
    return this.fields?.apiData?.groups || [];
  }

  get desktopImage(): TProductModelDetailsSpecificationTableBackgroundImage | undefined {
    return this.fields?.itemData?.fields?.imageParameters?.desktopImageData;
  }

  get mobileImage(): TProductModelDetailsSpecificationTableBackgroundImage | undefined {
    return this.fields?.itemData?.fields?.imageParameters?.mobileImageData;
  }

  get defaultBgDesktopImage(): TProductModelDetailsSpecificationTableBackgroundImage | undefined {
    return {
      url: this.context?.defaultBackgroundImageParameters?.desktopImageData?.productModelSpecificationTable,
    };
  }

  get defaultBgMobileImage(): TProductModelDetailsSpecificationTableBackgroundImage | undefined {
    return {
      url: this.context?.defaultBackgroundImageParameters?.mobileImageData?.productModelSpecificationTable,
    };
  }

  get desktopBgImage(): TProductModelDetailsSpecificationTableBackgroundImage | undefined {
    return this.desktopImage?.url ? this.desktopImage : this.defaultBgDesktopImage;
  }

  get mobileBgImage(): TProductModelDetailsSpecificationTableBackgroundImage | undefined {
    return this.mobileImage?.url ? this.mobileImage : this.defaultBgMobileImage;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
